import { AnchorHTMLAttributes } from 'react';
import { StyledAnchor } from './NoDecoAnchor.styles';

const NoDecoAnchor = (props: AnchorHTMLAttributes<HTMLAnchorElement>) => {
  return <StyledAnchor {...props} />;
};

export default NoDecoAnchor;
